var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedReadiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 14.7812L11.2812 1.75C10.7188 0.78125 9.25 0.75 8.6875 1.75L1.1875 14.7812C0.625 15.75 1.34375 17 2.5 17H17.4688C18.625 17 19.3438 15.7812 18.7812 14.7812ZM10 12.0625C10.7812 12.0625 11.4375 12.7188 11.4375 13.5C11.4375 14.3125 10.7812 14.9375 10 14.9375C9.1875 14.9375 8.5625 14.3125 8.5625 13.5C8.5625 12.7188 9.1875 12.0625 10 12.0625ZM8.625 6.90625C8.59375 6.6875 8.78125 6.5 9 6.5H10.9688C11.1875 6.5 11.375 6.6875 11.3438 6.90625L11.125 11.1562C11.0938 11.375 10.9375 11.5 10.75 11.5H9.21875C9.03125 11.5 8.875 11.375 8.84375 11.1562L8.625 6.90625Z",
    fill: "#DE2F1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedReadiness);
export default __webpack_public_path__ + "static/media/failed-readiness.3c88737cb.svg";
export { ForwardRef as ReactComponent };